module.exports = __webpack_public_path__ + "img/logo-new.8e97d072.jpg";